export default class Pip {
  constructor() {
    this.pipGtmCalled = false;
  }

  init() {
    this.bindScroll();
  }

  bindScroll(){
    var videoPlayer = document.querySelector('#article-player');
    var mainContent = document.querySelector('#main');
    var sidebarContent = document.querySelector('#article-sidebar');

    if (videoPlayer == null || mainContent == null || sidebarContent == null) return;

    var videoPlayerVjs = videoPlayer.querySelector('.vjs-container');
    window.addEventListener('scroll', function() {
      this.togglePip({
        videoPlayer: videoPlayer,
        videoPlayerVjs: videoPlayerVjs,
        mainContent: mainContent,
        sidebarContent: sidebarContent
      });
    }.bind(this));
  }

  sendImpression(){
    var videoId = this.videoId();
    var dt = {
      event: 'impression',
      feature_name: 'watchpage',
      feature_location: 'pip',
      feature_type: 'vod.' + videoId
    };

    window.dataLayer.push(dt);
  }

  togglePip(args={}){
    var mL = args.mainContent.offsetLeft,
        mW = args.mainContent.clientWidth,
        sW = args.sidebarContent.clientWidth;

    if(this.isPlayerNotVisible(args.videoPlayer)){
      //initiate PIP
      args.videoPlayerVjs.style.left = (mL + mW - sW) + 'px';
      args.videoPlayerVjs.style.width = sW + 'px';
      args.videoPlayer.classList.add('video-pip');

      if (!this.pipGtmCalled) {
        this.sendImpression();
        this.pipGtmCalled = true;
      }

    } else {
      //remove PIP
      args.videoPlayerVjs.style.removeProperty('left');
      args.videoPlayerVjs.style.removeProperty('width');
      args.videoPlayer.classList.remove('video-pip');
    }
  }

  isPlayerNotVisible(videoPlayerNode){
      var vT = videoPlayerNode.offsetTop,
      vH = videoPlayerNode.clientHeight,
      dS = document.documentElement.scrollTop || document.body.scrollTop;
    return (dS > (vT + vH - 200));
  }

  videoId() {
    if(window.kmklabs && window.kmklabs.video && window.kmklabs.video.id){
      return window.kmklabs.video.id;
    }

    return 0;
  }
}
